//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
  OnInit,
  signal,
} from "@angular/core";

//rxjs imports
import { filter, map, Subject, switchMap, takeUntil, timer } from "rxjs";


export interface ICheckable {
  select(value: boolean): void;
  isChecked(): boolean;
}

export interface ICheckable {
  select(value: boolean): void;
  isChecked(): boolean;
}

@Component({
    selector: "carousel-item",
    templateUrl: "./carousel-item.component.html",
    styleUrl: "./carousel-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselItemComponent<T extends ICheckable> implements OnInit, OnDestroy {
  public data = input.required<T>();
  public showSelection = input<boolean>(false);
  public showCount = input<boolean>(false);
  public shouldAddBreadcrumb = input<boolean>(true);

  public enableHover = input(true);

  public isExpanded = signal(false);

  private readonly destroying$ = new Subject<void>();
  private hoverIn$ = new Subject<void>();
  private hoverOut$ = new Subject<void>();

  constructor(
  ) {
    this.hoverIn$
    .pipe(
      filter(() => this.enableHover()),
      switchMap(() =>
        timer(600).pipe(
          takeUntil(this.hoverOut$),
          map(() => true)
        )
      ),
      takeUntil(this.destroying$) 
    )
    .subscribe(val => this.isExpanded.set(val));

  this.hoverOut$
    .pipe(takeUntil(this.destroying$))
    .subscribe(() => this.isExpanded.set(false));
  }


  public ngOnInit(): void {
    if(!this.shouldAddBreadcrumb()) {
      (this.data() as any)?.setShouldAddBreadcrumb?.(false);
    }
  }


  public onHover(state: 'in' | 'out') {
    if(this.enableHover()) {
      state === 'in' ? this.hoverIn$.next() : this.hoverOut$.next();
    } else {
         this.isExpanded.set(false); 
    }
  }



  public onSelectionChange(data: T) {
    data.select(!data.isChecked());    
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
    
    this.hoverIn$.complete();
    this.hoverOut$.complete();
  }
}
